import moment from "moment";

export const firstDay = (date = new Date(), type = "month") => {
	try {
		return firstDayMomentObj(date, type).format("YYYY-MM-DD");
	} catch {
		return "";
	}
};

export const firstDayMomentObj = (date = new Date(), type = "month") => {
	switch (type) {
		case "month":
			return moment(date).startOf("month").startOf("week");
		case "week":
			return moment(date).startOf("isoWeek");
		case "day":
			return moment(date).startOf("day");
		case "agenda":
			return moment();
		case "absolute_month":
			return moment(date).startOf("month");
		default:
			throw new Error("invalid type at firstDay()");
	}
};

export const lastDay = (date = new Date(), type = "month") => {
	try {
		return lastDayMomentObj(date, type).format("YYYY-MM-DD");
	} catch {
		return "";
	}
};

export const lastDayMomentObj = (date = new Date(), type = "month") => {
	switch (type) {
		case "month":
			return moment(date).endOf("month").endOf("week");
		case "week":
			return moment(date).endOf("isoWeek");
		case "day":
			return moment(date).endOf("day");
		case "agenda":
			return moment().add(1, "month");
		case "absolute_month":
			return moment(date).endOf("month");
		default:
			throw new Error("invalid type at lastDay()");
	}
};

const modulus = (num, divisor) => ((num % divisor) + divisor) % divisor;

const addMinute = (num, value) => {
	var num = parseInt(num) + value;
	var carryForward = 0;
	if (num > 60) {
		carryForward = 1;
	}
	return [num, carryForward];
};

const padAndBuildTimeString = (hour, minute, second) => {
	const checkLengthAndPad = (string) => (string.length < 2 ? "0" + string : string);
	[hour, minute, second] = [JSON.stringify(hour), JSON.stringify(minute), JSON.stringify(second)];
	return [checkLengthAndPad(hour), checkLengthAndPad(minute), checkLengthAndPad(second)].join(":");
};

export const transformDate = ({ unit, value, time }) => {
	if (!time) return "";
	const actionMapper = {
		hour: (time) => {
			const hour = JSON.stringify(modulus(parseInt(time.split(":")[0]) + value, 24));
			return [hour.length < 2 ? "0" + hour : hour, ...time.split(":").slice(1)].join(":");
		},
		minute: (time) => {
			var [hour, minute, second] = time.split(":");
			const [newMinute, carryForward] = addMinute(minute, value);
			hour += carryForward;

			return padAndBuildTimeString(hour, newMinute, second);
		},
		second: (time) => {},
		// skip minute and second first cause lazy
	};
	return actionMapper[unit](time);
};

export const tConv24 = (time24, includeTimePeriod = true) => {
	if (!time24) return "";
	var ts = time24;
	var H = +ts.substr(0, 2);
	var h = H % 12 || 12;
	h = h < 10 ? "0" + h : h; // leading 0 at the left for 1 digit hours
	var ampm = H < 12 ? "AM" : "PM";
	ts = h + ts.substr(2, 3) + ampm;
	return ts;
};

export const buildDateTime = (date, time = "12:00:00") => {
	const dateString = date + "T" + time + ".000+08:00";
	return new Date(dateString);
};

export const searchFirstSpecificDayOfMonth = (yearMonth, day) => {
	if (yearMonth === undefined || day === undefined) return undefined;
	day = Number(day);

	const [year, month] = String(yearMonth).split("-");
	const date = new Date(year, month - 1, 1);
	var searchFirstSpecificDay = firstDayMomentObj(date);
	while (searchFirstSpecificDay.isoWeekday() !== day + 1) {
		// add 1 day cause day index starts from 0
		searchFirstSpecificDay.add(1, "day");
	}
	return searchFirstSpecificDay;
};

const getMajorityDayOfMonth = (dateFrom, dateTo) => {
	if (!dateFrom || !dateTo) return 0;
	const clonedDateFrom = dateFrom.clone();
	const clonedDateTo = dateTo.clone();
	var month1MajorCount = 0,
		month2MajorCount = 0,
		month1 = clonedDateFrom.month(),
		month2 = clonedDateTo.month();
	while (clonedDateFrom.diff(clonedDateTo, "seconds") < 0) {
		clonedDateFrom.month() == Number(month1) ? month1MajorCount++ : month2MajorCount++;
		clonedDateFrom.add(1, "day");
	}
	if (month1MajorCount >= month2MajorCount) return month1 + 1;
	return month2 + 1;
};

export const getAllDaysOfSpecificDay = (yearMonth) => {
	if (yearMonth === undefined) return [];
	const [year, month] = yearMonth.split("-");
	// month - 1 because index starts from 0
	const currDate = searchFirstSpecificDayOfMonth(yearMonth, 0);
	var weekrange = [];

	for (var i = 0; i < 5; i++) {
		const dateFrom = currDate.clone();
		const dateTo = currDate.clone().endOf("isoWeek");
		const majorityMonth = getMajorityDayOfMonth(dateFrom, dateTo);
		if (Number(majorityMonth) === Number(month)) weekrange.push([dateFrom.format("DD MMM YYYY"), dateTo.format("DD MMM YYYY")]);
		currDate.add(1, "week");
	}
	return weekrange;
};

export const getSpecificDayOfWeek = ([dateFrom, dateTo], day) => {
	const currDate = moment(dateFrom);
	while (currDate.isoWeekday() !== Number(day) + 1) {
		currDate.add(1, "days");
	}

	return currDate;
};

export const getDaysInMonth = ({ year = new Date().getFullYear(), month = new Date().getMonth() }) => {
	return new Date(year, month, 0).getDate();
};

export const getWeekRangeOfMonth = ({ year = new Date().getFullYear(), month = new Date().getMonth(), carryForward = true }) => {
	let currDate = moment();
	currDate.set("year", year);
	currDate.set("month", month);
	currDate.set("date", 1);
	const daysInMonth = getDaysInMonth({ month });
	let weekArr = [];
	var i = 0;
	while (currDate.date() + 7 <= daysInMonth && i++ < 5) {
		weekArr.push({ start: currDate.toDate(), end: currDate.add(7, "day").toDate() });
	}
	if (carryForward) {
		weekArr[weekArr.length - 1].end.setDate(0);
		weekArr[weekArr.length - 1].end.setMonth(weekArr[weekArr.length - 1].end.getMonth() + 1);
	}

	return weekArr;
};

export const getPrevious12MonthsWeekRange = () => {
	const currDate = moment();
	const currMonth = currDate.month();
	const currYear = currDate.year();
	currDate.subtract(11, "month");
	var monthWeekRange = new Map();
	while (currDate.year().toString() + currDate.month().toString() < currYear.toString() + currMonth.toString()) {
		monthWeekRange.set(currDate.month(), getWeekRangeOfMonth({ year: currDate.year(), month: currDate.month() }));
		currDate.add(1, "month");
	}
	return monthWeekRange;
};

export function addTimes(startTime, endTime) {
	var times = [0, 0, 0];
	var max = times.length;

	var a = (startTime || "").split(":");
	var b = (endTime || "").split(":");

	// normalize time values
	for (var i = 0; i < max; i++) {
		a[i] = isNaN(parseInt(a[i])) ? 0 : parseInt(a[i]);
		b[i] = isNaN(parseInt(b[i])) ? 0 : parseInt(b[i]);
	}

	// store time values
	for (var i = 0; i < max; i++) {
		times[i] = a[i] + b[i];
	}

	var hours = times[0];
	var minutes = times[1];
	var seconds = times[2];

	if (seconds >= 60) {
		var m = (seconds / 60) << 0;
		minutes += m;
		seconds -= 60 * m;
	}

	if (minutes >= 60) {
		var h = (minutes / 60) << 0;
		hours += h;
		minutes -= 60 * h;
	}

	return ("0" + hours).slice(-2) + ":" + ("0" + minutes).slice(-2) + ":" + ("0" + seconds).slice(-2);
}
